import React from 'react';
import { Button, PageHeader, Typography, Col } from 'antd';
import '../About.css';
const AboutHeader = (props) => {
    const { Title } = Typography;
    return (
<div>
{props.aboutcompany?
    <div>
     {props.children ?? null}
     <div style={{paddingTop: '10px'}}></div>
     <div className='about-title'>{props.BidApply}</div>
     <div className='company-desc-label'>{props.bidspan}</div>
     <div style={{paddingBottom: '10px'}}></div>
</div>

:
 <div className="About-header">
 <Col lg={28} md={24} sm={20} xs={28}>
     {props.children ?? null}
     <Title level={4}>{props.BidApply}</Title>
     <span className="about-company-description" >{props.bidspan}</span>
     <p style={{backgroundColor:'black'}}></p>
 </Col>
</div>
}
</div>

    )
}
export default AboutHeader;
